// src/pages/Coordenacao/CoordenacaoEmbarcacoesClientes.tsx
import React, { useMemo } from "react";
import Table from "../../../../../components/TableV2";
import TitleButtons from "../../../../../components/TitleButtons";
import { useEmbarcacoesClientes } from "./embarcacoesCadastradasData";
import { useNavigate } from "react-router-dom";
import TableActions from "../../../../../components/TableActions";

type Row = React.ReactNode[];

type Props = {
  /** Título exibido no topo da página */
  title?: string;
};

// ======================= Página =======================
const EmpresasClientes: React.FC<Props> = ({ title }) => {
  const navigate = useNavigate();
  const { data, loading, error } = useEmbarcacoesClientes();

  const headers = useMemo(() => ["Nome da Embarcação", "Empresa"], []);

  //            Nome da Embarcação   Empresa
  const columnWidths = useMemo(() => ["360px", "480px"], []);

  const rows: Row[] = useMemo(() => {
    return data.map((item) => [
      item.nome_embarcacao || "-",
      item.nome_empresa || "-",
    ]);
  }, [data]);

  return (
    <div>
      <TitleButtons fullBleedLine title={title ?? ""} />
      <TableActions
        buttons={[
          {
            label: "Registrar Embarcação",
            onClick: () =>
              navigate("/coordenacao/embarcacoes/registrar-embarcacao"),
            variant: "primary",
          },
        ]}
      />

      {loading && (
        <p style={{ marginBottom: "8px" }}>Carregando embarcações...</p>
      )}

      {error && !loading && (
        <p style={{ color: "red", marginBottom: "8px" }}>
          Erro ao carregar embarcações: {error.message}
        </p>
      )}

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        responsiveWidths={{
          // em telas menores podemos só encolher as colunas
          1000: {
            0: "260px", // Nome da Embarcação
            1: "300px", // Empresa
          },
          700: {
            0: "200px",
            1: "220px",
          },
        }}
      />
    </div>
  );
};

export default EmpresasClientes;
